export const theme = {
  colors: {
    primary: '#000000',
    white: '#ffffff',
    secondary: '#fff9f3',
    remondis_accent: '#ed1c24',
    alecta_accent: '#006cf2',
    grayscale: 'rgba(0, 0, 0, 0.4)',
    grayscale_2: 'rgba(0, 0, 0, 0.3)',
  },
  dimensions: {
    components: {
      borderRadius: '30px',
    },
    card: {
      borderRadius: '40px',
      width: '800px',
      height: '425px',
    },
  },
  columns: {
    gap: '10px',
  },
  segments: {
    columns: 3,
    rows: 3,
  },
  materials: {
    columns: 4,
    selectedBackgroundColor: '#e3e9e9',
    selectedBorder: '#197149',
  },
  contactForm: {
    width: '700px',
  },
};
